import React from 'react';
import Avatar from '@material-ui/core/Avatar';

const TeamAvatar = ({ team, className }) => {
    const normalizeLogoUrl = (value) => {
        if (!value) return '';
        const logo = String(value).trim();
        if (!logo) return '';
        if (logo.startsWith('http://') || logo.startsWith('https://') || logo.startsWith('data:') || logo.startsWith('blob:')) {
            return logo;
        }
        if (logo.startsWith('//')) {
            return `https:${logo}`;
        }
        if (logo.startsWith('/')) {
            return logo;
        }

        // Exemple: "syncstats.ca/clientfiles/Teams_1422"
        var indexPremiereBarre = logo.indexOf('/');
        var tete = indexPremiereBarre > 0 ? logo.substring(0, indexPremiereBarre) : logo;
        if (tete.indexOf('.') >= 0) {
            return `https://${logo}`;
        }

        // Exemple: "clientfiles/Teams_1422" ou "devclientfiles/Teams_1422"
        return `https://syncstats.ca/${logo.replace(/^\/+/, '')}`;
    };

    const rawLogo = team && team.logoUrl ? team.logoUrl : '';
    const currentSource = normalizeLogoUrl(rawLogo);
    const initial = team && team.name ? team.name.charAt(0) : 'E';

    return (
        <Avatar className={className} src={currentSource}>
            {initial}
        </Avatar>
    );
};

export default TeamAvatar;
